import React from "react";
import { Button, ButtonGroup } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TextButtonGroupHorz = () => {
  return (
    <>
      <PreviewAndEditor
        language="js"
        title={"Text primary button group"}
        value={
          '<ButtonGroup variant={"text"} aria-label="text primary button group">\n\t<Button>One</Button>\n\t<Button>Two</Button>\n\t<Button>Three</Button>\n</ButtonGroup>'
        }
      >
        <ButtonGroup variant={"text"} aria-label="text primary button group">
          <Button>One</Button>
          <Button>Two</Button>
          <Button>Three</Button>
        </ButtonGroup>
      </PreviewAndEditor>
    </>
  );
};

export default TextButtonGroupHorz;
